// extracted by mini-css-extract-plugin
export default {"info":"receipt_info__0SMbO","emptyFiltered":"receipt_emptyFiltered__fcKH-","footer":"receipt_footer__DxAwv","footerStuck":"receipt_footerStuck__RqEHC"};